const authUrl = 'https://auth-v3.wukongkeyan.com/api/v1'; //auth域名

export {
  authUrl
}



// WEBPACK FOOTER //
// ./src/api/auth_http.js